<button #originTerms="voxelOverlayOrigin" voxelOverlayOrigin style="display: none;"></button>
<form [formGroup]="form" autocomplete="off">
    <div class="row">
        <voxel-form-selection
        *ngIf="CONTENT_BOUNDS?.terms; let control;"
        class="voxel-col-xs-4 voxel-col-sm-4 voxel-col-md-6">
        <input type="checkbox" formControlName="chktycmodal" (change)="changeTerms()" voxelCheckbox required/>
        <span class="text-justify">{{control?.text}}
            <button voxelButtonAction (click)="displayEv()" [textContent]="control?.label" class="voxel-col-11 voxel-col-sm-3" [title]="control?.label"></button>.
        </span>
        <a [id]="control?.download_name" class="page-size-select" [download]="control?.link" [href]="control?.link" target="_blank" [textContent]="control?.label" style="visibility: hidden;"></a>
        </voxel-form-selection>
    </div>
</form>
<div *ngIf="CONTENT_BOUNDS?.terms; let ctr">
    <voxel-modal id="modalTerms" [modalIsOpen]="viewTerms" [modalOrigin]="originTerms" (modalClose)="close($event)">
        <div>
            <div style="border:none;">
                <div style="border:none;" class="voxel-pb-3">
                <div>
                    <b [textContent]="ctr?.title" class="voxel-text-title-01"></b>
                </div>
                </div>
                <div style="text-align: justify;">
                <p [textContent]="ctr?.content">
                </div>
            </div>
            </div>
            <div voxelModalFooter>
            <a id="download_terms" class="page-size-select" [download]="ctr?.link" [href]="ctr?.link" target="_blank" [textContent]="ctr?.label" style="visibility: hidden;" ></a>
            <div class="voxel-row" style="display: inline-flex; justify-content: center;">
                <button voxelButton buttonStyle="secondary" [textContent]="ctr?.download" (click)="download()" class="voxel-col-4"></button>
                <button voxelButton buttonStyle="primary" (click)="displayEv()" [textContent]="ctr?.close" class="voxel-col-4"></button>
            </div>
        </div>
    </voxel-modal>
</div>